import { MUTATIONS } from "@/constants/mutations";
import { MutationTree } from "vuex";
import { AdminState } from "./admin.module";
import { ProductData } from "@/interfaces/product-data.model";
import LINK from "@/utils/link";

export const ADMIN_MUTATIONS: MutationTree<AdminState> = {
  // product
  [MUTATIONS.admin.setProduct](state, data: ProductData): void {
    state.productData = data;
    if (data.img !== "") {
      state.productData.img = `${LINK}images/upload-product-images/${data.img}`;
    }
  },
  [MUTATIONS.admin.setProducts](state, data: any): void {
    state.adminProducts = data;
  },
  [MUTATIONS.admin.editProduct](state, payload): void {
    const identifiedProductIndex = state.adminProducts.findIndex(
      (prod) => prod.id === payload.id
    );
    if (identifiedProductIndex > -1) {
      state.adminProducts[identifiedProductIndex] = payload.data;
    }
  },
  [MUTATIONS.admin.deleteProduct](state, id: string): void {
    // find index
    const identifiedProductIndex = state.adminProducts.findIndex(
      (prod) => prod.id === id
    );

    // delete the product from products' list by index
    if (identifiedProductIndex > -1) {
      state.adminProducts.splice(identifiedProductIndex, 1);
    }
  },
  [MUTATIONS.admin.updateProductName](state, value: string): void {
    state.productData.name = value;
  },
  [MUTATIONS.admin.updateProductCategory](state, value: string): void {
    state.productData.category = value;
  },
  [MUTATIONS.admin.updateProductAmount](state, value: number): void {
    state.productData.amount = value;
  },
  [MUTATIONS.admin.updateProductSpecialSell](state, value: number): void {
    state.productData.special_sell = value;
  },
  [MUTATIONS.admin.updateProductInventory](state, value: number): void {
    state.productData.inventory = value;
  },
  [MUTATIONS.admin.updateProductDescription](state, value: string): void {
    state.productData.description = value;
  },
  [MUTATIONS.admin.updateProductSpecial](state, value: boolean): void {
    state.productData.special = value;
  },
  [MUTATIONS.admin.updateProductNew](state, value: boolean): void {
    state.productData.newProduct = value;
  },
  [MUTATIONS.admin.updateProductImage](state, value: string): void {
    state.productData.img = value;
  },
  // landing
  [MUTATIONS.admin.updateMainBannerAboutUs](state, value: string): void {
    state.landing.aboutUs.mainBanner = value;
  },

  [MUTATIONS.admin.updateAboutUsLanguage](state, language: string): void {
    state.landing.aboutUs.language = language;
  },

  [MUTATIONS.admin.updateAboutUsTitle](state, title: string): void {
    state.landing.aboutUs.title = title;
  },
  [MUTATIONS.admin.updateAboutUsDescription](state, description: string): void {
    state.landing.aboutUs.description = description;
  },
  [MUTATIONS.admin.updateAluminiumLanguage](state, language: string): void {
    state.landing.aluminiumCategory.language = language;
  },
  [MUTATIONS.admin.updateAluminiumTitle](state, title: string): void {
    state.landing.aluminiumCategory.title = title;
  },
  [MUTATIONS.admin.updatePotlidLanguage](state, language: string): void {
    state.landing.potlidCategory.language = language;
  },
  [MUTATIONS.admin.updatePotlidTitle](state, title: string): void {
    state.landing.potlidCategory.title = title;
  },
  [MUTATIONS.admin.updateContactUsTitle](state, title: string): void {
    state.landing.contactUs.title = title;
  },
  [MUTATIONS.admin.updateContactUsSubTitle](state, subTitle: string): void {
    state.landing.contactUs.subTitle = subTitle;
  },
  [MUTATIONS.admin.updateContactUsAddress](state, address: string): void {
    state.landing.contactUs.address = address;
  },
  [MUTATIONS.admin.updateContactUsEmail](state, email: string): void {
    state.landing.contactUs.email = email;
  },
  [MUTATIONS.admin.updateContactUsPhone](state, phone: string): void {
    state.landing.contactUs.phone = phone;
  },
  [MUTATIONS.admin.updateContactUsLanguage](state, language: string): void {
    state.landing.contactUs.language = language;
  },
  // major shopping
  [MUTATIONS.admin.updateMajorShoppingLanguage](state, language: string): void {
    state.landing.majorShopping.language = language;
  },
  [MUTATIONS.admin.updateMajorShoppingTitle](state, title: string): void {
    state.landing.majorShopping.title = title;
  },
  [MUTATIONS.admin.updateFaqDataTitle](state, title: string): void {
    state.landing.faqData.title = title;
  },
  [MUTATIONS.admin.updateMajorShoppingDescription](
    state,
    description: string
  ): void {
    state.landing.majorShopping.text = description;
  },
  [MUTATIONS.admin.updateMajorShoppingSubTitle](state, subTitle: string): void {
    state.landing.majorShopping.subTitle = subTitle;
  },
  [MUTATIONS.admin.updateMainBannerMajorShopping](
    state,
    mainBanner: string
  ): void {
    state.landing.majorShopping.mainBanner = mainBanner;
  },
  [MUTATIONS.admin.updateFaqDataLanguage](state, language: string): void {
    state.landing.faqData.language = language;
  },
  [MUTATIONS.admin.updateFaqDataDescription](state, description: string): void {
    state.landing.faqData.description = description;
  },
  // offers
  [MUTATIONS.admin.updateOfferDataTitle](state, title: string): void {
    state.landing.offerData.title = title;
  },
  [MUTATIONS.admin.updateOfferDataLanguage](state, language: string): void {
    state.landing.offerData.language = language;
  },
  [MUTATIONS.admin.updateOfferDataDescription](
    state,
    description: string
  ): void {
    state.landing.offerData.description = description;
  },

  // category and product landing
  [MUTATIONS.admin.updateLandingProductName](state, title: string): void {
    state.landing.productData.name = title;
  },
  [MUTATIONS.admin.updateLandingProductColor](state, color): void {
    state.landing.productData.colors = color;
  },
  [MUTATIONS.admin.updateLandingProductSize](state, size): void {
    state.landing.productData.sizes = size;
  },
  [MUTATIONS.admin.updateLandingProductCategory](
    state,
    category: string
  ): void {
    state.landing.productData.category = category;
  },
  [MUTATIONS.admin.updateLandingProductType](state, type: string): void {
    state.landing.productData.type = type;
  },
  [MUTATIONS.admin.updateLandingProductAmount](state, amount: string): void {
    state.landing.productData.amount = amount;
  },
  [MUTATIONS.admin.updateLandingProductDescription](
    state,
    description: string
  ): void {
    state.landing.productData.description = description;
  },
  [MUTATIONS.admin.updateLandingProductImage](state, img): void {
    state.landing.productData.img = img;
  },

  // landing category
  [MUTATIONS.admin.updateCategoryPersianTitle](
    state,
    persianTitle: string
  ): void {
    state.landing.categoryData.persianTitle = persianTitle;
  },
  [MUTATIONS.admin.updateSubCategoryPersianTitle](
    state,
    persianTitle: string
  ): void {
    state.landing.subCategoryData.persianTitle = persianTitle;
  },
  [MUTATIONS.admin.updateSubCategoryEnglishTitle](
    state,
    englishTitle: string
  ): void {
    state.landing.subCategoryData.englishTitle = englishTitle;
  },
  [MUTATIONS.admin.updateSubCategoryArabicTitle](
    state,
    arabicTitle: string
  ): void {
    state.landing.subCategoryData.arabicTitle = arabicTitle;
  },
  [MUTATIONS.admin.updateLandingSubCategory](state, subCategory: string): void {
    state.landing.subCategoryData.category = subCategory;
  },
  [MUTATIONS.admin.updateCategoryType](state, categoryType: string): void {
    state.landing.categoryData.categoryType = categoryType;
  },
  [MUTATIONS.admin.updateCategoryEnglishTitle](
    state,
    EnglishTitle: string
  ): void {
    state.landing.categoryData.englishTitle = EnglishTitle;
  },
  [MUTATIONS.admin.updateCategoryArabicTitle](
    state,
    arabicTitle: string
  ): void {
    state.landing.categoryData.arabicTitle = arabicTitle;
  },
  [MUTATIONS.admin.updateCategoryDescription](
    state,
    description: string
  ): void {
    state.landing.categoryData.description = description;
  },
  [MUTATIONS.admin.updateCategoryImage](state, img): void {
    state.landing.categoryData.img = img;
  },
  [MUTATIONS.admin.updateCategoryImageEdit](state, img): void {
    state.landing.categoryEdit.img = img;
  },
  [MUTATIONS.admin.updateSelectedLandingProductName](state, name): void {
    state.landing.selectedLandingProduct.name = name;
  },
  [MUTATIONS.admin.updateSelectedLandingProductCategory](
    state,
    category
  ): void {
    state.landing.selectedLandingProduct.category = category;
  },
  [MUTATIONS.admin.updateSelectedLandingProductImage](state, image): void {
    state.landing.selectedLandingProduct.img = image;
  },
  [MUTATIONS.admin.updateSelectedLandingProductType](state, type): void {
    state.landing.selectedLandingProduct.type = type;
  },
  [MUTATIONS.admin.updateSelectedLandingProductAmount](state, amount): void {
    state.landing.selectedLandingProduct.amount = amount;
  },
  [MUTATIONS.admin.updateSelectedLandingProductDescriptionSizes](
    state,
    sizes
  ): void {
    state.landing.selectedLandingProduct.sizes = sizes;
  },
  [MUTATIONS.admin.updateSelectedLandingProductDescriptionColors](
    state,
    colors
  ): void {
    state.landing.selectedLandingProduct.colors = colors;
  },
  [MUTATIONS.admin.updateSelectedLandingProductDescription](
    state,
    description
  ): void {
    state.landing.selectedLandingProduct.description = description;
  },
  [MUTATIONS.admin.updateCategoryBanner](state, banner): void {
    state.landing.categoryData.mainBanner = banner;
  },
  [MUTATIONS.admin.updateBannerCategory](state, img): void {
    state.landing.bannerCategory.img = img;
  },
  // certificates
  [MUTATIONS.admin.updateCertificatesLanguage](state, language: string): void {
    state.landing.certificates.language = language;
  },
  [MUTATIONS.admin.updateCertificatesTitle](state, title: string): void {
    state.landing.certificates.title = title;
  },
  [MUTATIONS.admin.updateCertificatesText](state, text: string): void {
    state.landing.certificates.text = text;
  },
  [MUTATIONS.admin.upadetCertificateImage](state, img): void {
    state.landing.certificates.image = img;
  },
  // catalogs
  [MUTATIONS.admin.updateCatalogLink](state, link: string): void {
    state.landing.catalogData.link = link;
  },
  [MUTATIONS.admin.updateCatalogText](state, text: string): void {
    state.landing.catalogData.text = text;
  },
  [MUTATIONS.admin.upadetCatalogImage](state, img): void {
    state.landing.catalogData.img = img;
  },
  [MUTATIONS.admin.updateCatalogLanguage](state, language): void {
    state.landing.catalogData.language = language;
  },
  // more box
  [MUTATIONS.admin.updateMoreBoxContentTitle](state, title: string): void {
    state.landing.moreBoxContent.title = title;
  },
  [MUTATIONS.admin.updateMoreBoxContentDescription](
    state,
    description: string
  ): void {
    state.landing.moreBoxContent.description = description;
  },
  [MUTATIONS.admin.updateMoreBoxContentImage](state, img): void {
    state.landing.moreBoxContent.img = img;
  },
  // home page
  [MUTATIONS.admin.updateMainBannerHomePage](state, mainBanner: string): void {
    state.landing.homePage.mainBanner = mainBanner;
  },
  [MUTATIONS.admin.updateShopMainBanner](state, mainBanner: string): void {
    state.landing.shopMainBanner.img = mainBanner;
  },
  [MUTATIONS.admin.updateMainBannerHomePageAboutUs](
    state,
    mainBanner: string
  ): void {
    state.landing.homePage.aboutUs.mainBanner = mainBanner;
  },
  [MUTATIONS.admin.updateVideoPage](state, position: string): void {
    state.landing.videoData.position = position;
  },
  [MUTATIONS.admin.updateVideoLink](state, video: string): void {
    state.landing.videoData.video = video;
  },
  [MUTATIONS.admin.updateVideoDataTitle](state, title: string): void {
    state.landing.videoData.title = title;
  },
  [MUTATIONS.admin.updateVideoDataSubTitle](state, subTitle: string): void {
    state.landing.videoData.subTitle = subTitle;
  },
  [MUTATIONS.admin.updateVideoDataDescription](
    state,
    description: string
  ): void {
    state.landing.videoData.description = description;
  },
  // footer address
  [MUTATIONS.admin.updateFooterAddressLanguage](state, language: string): void {
    state.landing.footerAddress.language = language;
  },
  [MUTATIONS.admin.updateFooterAddressAddress](state, address: string): void {
    state.landing.footerAddress.address = address;
  },
  [MUTATIONS.admin.updateFooterAddressPhone](state, phone: string): void {
    state.landing.footerAddress.phone = phone;
  },
  [MUTATIONS.admin.updateFooterAddressEmail](state, email: string): void {
    state.landing.footerAddress.email = email;
  },
  [MUTATIONS.admin.updateFactoryAddressAddress](state, address: string): void {
    state.landing.factoryAddress.address = address;
  },
  [MUTATIONS.admin.updateFactoryAddressLanguage](
    state,
    language: string
  ): void {
    state.landing.factoryAddress.language = language;
  },
  // major shopping info
  [MUTATIONS.admin.updateMajorShoppingInfoLanguage](
    state,
    language: string
  ): void {
    state.landing.majorShoppingInfo.language = language;
  },
  [MUTATIONS.admin.updateMajorShoppingInfoPhone](state, phone: string): void {
    state.landing.majorShoppingInfo.phone = phone;
  },
  [MUTATIONS.admin.updateMajorShoppingInfoEmail](state, email: string): void {
    state.landing.majorShoppingInfo.email = email;
  },
  [MUTATIONS.admin.updateMajorShoppingInfoAddress](
    state,
    address: string
  ): void {
    state.landing.majorShoppingInfo.address = address;
  },
  [MUTATIONS.admin.updateHomePageAboutUsTitle](state, title: string): void {
    state.landing.homePage.aboutUs.title = title;
  },
  [MUTATIONS.admin.updateHomePageAboutUsSubTitle](
    state,
    subTitle: string
  ): void {
    state.landing.homePage.aboutUs.subTitle = subTitle;
  },
  [MUTATIONS.admin.updateHomePageAboutUsLanguage](
    state,
    language: string
  ): void {
    state.landing.homePage.aboutUs.language = language;
  },
  [MUTATIONS.admin.updateHomePageAboutUsDescription](
    state,
    desfcription: string
  ): void {
    state.landing.homePage.aboutUs.text = desfcription;
  },
  [MUTATIONS.admin.updateHomePageStatueTitle](state, title: string): void {
    state.landing.homePage.statue.title = title;
  },
  [MUTATIONS.admin.updateHomePageStatueLanguage](
    state,
    language: string
  ): void {
    state.landing.homePage.statue.language = language;
  },
  [MUTATIONS.admin.updateHomePageStatueDescription](
    state,
    description: string
  ): void {
    state.landing.homePage.statue.text = description;
  },
  [MUTATIONS.admin.updateStatueImage](state, statueImage: string): void {
    state.landing.homePage.statue.statueImage = statueImage;
  },

  [MUTATIONS.admin.resetProductData](state): void {
    state.productData = {
      name: "",
      img: "",
      images: [],
      inventory: 1,
      category: "",
      amount: 0,
      userOpinions: [],
      special_sell: 0,
      description: "",
      special: false,
      newProduct: false,
    };
  },
  // category
  [MUTATIONS.admin.updateCategoryTitle](state, value: string): void {
    state.categoryData.title = value;
  },
  [MUTATIONS.admin.updateCategoryParent](state, value: string | null): void {
    state.categoryData.parent = value;
  },
  [MUTATIONS.admin.updateCategoryParentPath](state, value: string): void {
    state.categoryData.parentPath = value;
  },
  [MUTATIONS.admin.resetCategoryData](state): void {
    state.categoryData = {
      title: "",
      parentPath: "/",
      parent: null,
    };
  },
  // user
  [MUTATIONS.admin.setUsersList](state, data): void {
    state.usersList = data;
  },
  [MUTATIONS.admin.setUserProfile](state, value): void {
    state.userProfile = value;
  },
  [MUTATIONS.admin.setUserFullname](state, value): void {
    state.userProfile.fullname = value;
  },
  [MUTATIONS.admin.setUserAddress](state, value): void {
    state.userProfile.address = value;
  },
  [MUTATIONS.admin.setUserProvince](state, value): void {
    state.userProfile.province = value;
  },
  [MUTATIONS.admin.setUserCity](state, value): void {
    state.userProfile.city = value;
  },
  [MUTATIONS.admin.setUserAvatar](state, value): void {
    state.userProfile.avatar = value;
  },
  // set amount wallet user charge
  [MUTATIONS.admin.setAmountWalletCharge](state, value: number): void {
    state.amountWalletCharge.amount = value;
  },
  [MUTATIONS.admin.removeUserAvatar](state): void {
    state.userProfile.avatar = "";
  },
  // admins
  [MUTATIONS.admin.setAdminsList](state, data): void {
    state.adminsList = data;
  },
  // invoices
  [MUTATIONS.admin.setInvoicesList](state, data): void {
    state.invoicesList = data;
  },
};
